import React, { useEffect } from "react";
// import useAnimation from "../../../services/functions/useAnimation";
// import useFetch from "../../../services/functions/useFetch";
// import CustomAlert from "../../CustomAlert";
// import snowflake from "../../../assets/icons/loading-snowflake.svg";
import { useNavigate } from "react-router-dom";

// interface Age {
//   id: number;
//   title: string;
// }
// interface AgeData {
//   ages: Age[];
// }

function MenuAge() {
  // const { slideIn, slideOutAll: slideOut } = useAnimation();
  // const { data, error, isPending, fetchData } = useFetch<AgeData>();
  const navigate = useNavigate();

  // useEffect(() => {
  //   slideIn(".list__item"); // * applying of smooth animation when elements appear
  // }, [slideIn]);

  useEffect(() => {
    navigate(`skill?age=${localStorage.getItem("kids") === "true" ? "1" : "2"}`);

    // fetchData("/get/ages/", "GET", {
    //   doOnSuccess: (response) => {},
    //   doOnError: () => {
    //     console.error("Failed to fetch ages.");
    //   },
    // });
  }, []);

  return (
    <>
      {/* {error && <CustomAlert message={error} type="error" />}
      {isPending ? (
        <img src={snowflake} alt="loading" className="loading-snowflake" />
      ) : (
        <ul className="page__list list">
          {data?.ages?.map((age) => (
            <li className="list__item" key={age.id}>
              <button
                onClick={async () => await slideOut(".list__item", `/skill?age=${age.id}`)} // * applying of smooth animation when elements disappear
                className="list__link list__link-hover"
                data-name={age.title}
              >
                {age.title}
              </button>
            </li>
          ))}
        </ul>
      )} */}
    </>
  );
}

export default MenuAge;
